<form [formGroup]="_form" #formDirective="ngForm" (ngSubmit)="sendNotification()">

  <!--title-->
  <h2 mat-dialog-title>
    <i class="material-icons m-r-10">notifications_none</i>
    <span>{{'Layout.TopNavbar.SendNotifications.Title' | translate}}</span>
  </h2>

  <!--content-->
  <mat-dialog-content>

    <mat-form-field>
      <input matInput formControlName="message" #messageCharacterCount maxLength="140" placeholder="{{'Layout.TopNavbar.SendNotifications.Message' | translate}}" />
      @if (message.errors?.required && message.touched) {
        <mat-error>
          {{'Commons.Validation.Required' | translate : { field: "Layout.TopNavbar.SendNotifications.Message" | translate } }}
        </mat-error>
      }
      <mat-hint align="end">
        {{messageCharacterCount.value.length}} / 140
      </mat-hint>
    </mat-form-field>

    <mat-form-field>
      <mat-select class="block" formControlName="userId" placeholder="{{'Layout.TopNavbar.SendNotifications.SelectRecipient' | translate}}">
        @for (_recipient of _pushNotificationsRecipients; track _recipient) {
          <mat-option [value]="_recipient.userId">
            {{_recipient.name}}
          </mat-option>
        }
      </mat-select>
      @if (userId.errors?.required && userId.touched) {
        <mat-error>
          {{'Commons.Validation.Required' | translate : { field: "Layout.TopNavbar.SendNotifications.SelectRecipient" | translate } }}
        </mat-error>
      }
    </mat-form-field>

  </mat-dialog-content>

  <!--actions-->
  <mat-dialog-actions>
    <button type="submit" mat-flat-button mat-ripple color="accent" [class.disabled]="!_form.valid">
      {{ 'Commons.Actions.Confirm' | translate }}
    </button>
    <button type="button" mat-button mat-ripple mat-dialog-close>
      {{'Commons.Actions.Cancel' | translate}}
    </button>
  </mat-dialog-actions>

</form>